import React, { useState } from 'react';
import cx from './ventureCard.module.scss';
import { ventureideabanner, ventureprototypebanner, venturescalingbanner, venturetractionbanner } from 'src/assets/images';

export default function SimilarVentureProfile({ venture }: any) {
    // state 
    const [isLoading, setIsLoading] = useState(true);
    // constant && derived state
    const bannerArr = [{ type: 'Idea', banner: ventureideabanner }, { type: 'Prototype', banner: ventureprototypebanner }, { type: 'Scaling', banner: venturescalingbanner }, { type: 'Early Traction', banner: venturetractionbanner }]
    const banner = venture.banner && isLoading ? venture?.banner : bannerArr.find((item) => item.type === venture.ventureStage)?.banner

    return (
        <div className={cx.ideaslikeInner}>
            <img src={banner} alt="banner" onError={() => setIsLoading(false)} />
            <div className={cx.ideaslikeContent} >
                <h4>{venture.title}</h4>
                <span>{venture.domain}</span>
            </div>
        </div>
    )
}
